import { render, staticRenderFns } from "./PsLanguageSwitcher.vue?vue&type=template&id=34f6703a&scoped=true&"
import script from "./PsLanguageSwitcher.vue?vue&type=script&lang=js&"
export * from "./PsLanguageSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./PsLanguageSwitcher.vue?vue&type=style&index=0&id=34f6703a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f6703a",
  null
  
)

export default component.exports